import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const BookIcon = ({ className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="801.8px"
        height="602.3px"
        viewBox="0 0 801.8 602.3"
        xmlSpace="preserve"
        className={className}
    >
        <path
            fill="#2151ff"
            d="M584.9,37.1C642.7,20.2,702.4,2.7,764.7,0l-3.1,500.9c-62.8,2.7-122.8,20.2-180.8,37.2-51.2,15-103.9,30.4-158.6,35.6l-21.1,1.4,3.1-500.8c62.8-2.7,122.8-20.2,180.8-37.2ZM40.8,49.5c62.4-6,122,3.3,179.7,12.3,57.8,9,117.6,18.3,180.2,12.4l-3.1,500.9c-62.4,6-122-3.3-179.7-12.3-43.2-6.7-87.6-13.6-133.4-14.2-15.4-.2-31.1.3-46.9,1.8l3.1-500.9ZM3.2,85.2l34.1-2.3-2.9,470.8,1.9-.2c62.9-6.3,123,3.1,181.2,12.2,38.9,6.1,78.7,12.2,119.7,13.8L0,602.3,3.2,85.2ZM798.6,548.2l-334.4,22.7c40.2-7.3,79.3-18.7,117.5-29.9,58.3-17.1,118.6-34.7,181.5-37.2h1.6c0,0,2.9-470.4,2.9-470.4l34.1-2.3-3.2,517.1Z"
        />
    </svg>
);

BookIcon.propTypes = propTypes;
BookIcon.defaultProps = defaultProps;

export default BookIcon;
